import type { LucideProps } from 'lucide-react';
import { createElement } from 'react';

import { categoryIcon, type ProgramCategoryCode } from '@/config/program-category';

/** 사업 유형 아이콘 — 미등록 code 는 기본 아이콘(specs/033 FR-007). */
export function CategoryIcon({ code, ...props }: LucideProps & { code: ProgramCategoryCode }) {
  return createElement(categoryIcon(code), props);
}
